<!-- Search Form Start-->
<div class="sigma_search-form-wrapper" [ngClass]="searchMethod ? 'open' : ''">
    <div class="sigma_search-trigger close-btn" (click)="toggleSearch()">
        <span></span>
        <span></span>
    </div>
    <form class="sigma_search-form">
        <input type="text" placeholder="Search..." required>
        <button type="submit" class="sigma_search-btn">
            <i class="fal fa-search"></i>
        </button>
    </form>
</div>
<!-- Search Form End-->
<!-- Cart Sidebar -->
<div class="sigma_cart-sidebar-wrapper sigma_aside sigma_aside-right" [ngClass]="cartMethod ? 'cart-open' : ''">
    <aside class="sigma_cart-sidebar">
        <div class="sigma_cart-sidebar-header">
            <h4>Your Cart</h4>
            <div class="close-btn sigma_cart-trigger close-dark" (click)="toggleCart()">
                <span></span>
                <span></span>
            </div>
        </div>
        <app-cart class="h-100"></app-cart>
    </aside>
</div>
<div class="sigma_aside-overlay sigma_cart-sidebar-overlay sigma_cart-trigger" (click)="toggleCart()"></div>
<!-- Aside (Right Panel) -->
<aside class="sigma_aside sigma_aside-right sigma_aside-right-panel sigma_aside-bg" [ngClass]="canvasMethod ? 'open' : ''">
    <app-canvas></app-canvas>
</aside>
<div class="sigma_aside-overlay aside-trigger-right" (click)="toggleCanvas()"></div>
<!-- partial:partia/__mobile-nav.html -->
<aside class="sigma_aside sigma_aside-left" [ngClass]="navmethod ? 'open' : ''">
    <app-mobile-menu></app-mobile-menu>
</aside>
<div class="sigma_aside-overlay aside-trigger-left" (click)="toggleNav()"></div>
<!-- partial -->
<!-- partial:partia/__header.html -->
<header class="sigma_header header-fw header-2">
    <div class="sigma_header-top">
        <div class="container">
            <div class="sigma_header-top-inner">
                <ul class="sigma_header-top-links">
                    <li class="menu-item"> <a href="tel:+123456789"> <i class="fal fa-phone"></i> (+123) 123 4567 890</a> </li>
                    <li class="menu-item"> <a href="mailto:info@example.com"> <i class="fal fa-envelope"></i> info@example.com</a> </li>
                </ul>
                <ul class="sigma_sm">
                    <li> <a href="#"> <i class="fab fa-facebook-f"></i> </a> </li>
                    <li> <a href="#"> <i class="fab fa-twitter"></i> </a> </li>
                    <li> <a href="#"> <i class="fab fa-instagram"></i> </a> </li>
                </ul>
            </div>
        </div>
    </div>
    <!-- Middle Header Start -->
    <div class="sigma_header-middle">
        <div class="container">
            <nav class="navbar">
                <!-- Logo Start -->
                <div class="sigma_logo-wrapper">
                    <a class="navbar-brand" routerLink="/">
                        <img src="assets/img/logo-3.png" alt="logo">
                    </a>
                </div>
                <!-- Logo End -->
                <!-- Menu -->
                <ul class="navbar-nav">
                    <li class="menu-item" [ngClass]="item.child === true ? 'menu-item-has-children' : ''"
                        *ngFor="let item of navigation">
                        <a href="javascript:void(0)" *ngIf="item.child">{{item.linkText}}</a>
                        <a routerLink="{{item.link}}" *ngIf="!item.child">{{item.linkText}}</a>
                        <ul class="sub-menu" *ngIf="item.child">
                            <li class="menu-item" [ngClass]="item.child === true ? 'menu-item-has-children' : ''"
                                *ngFor="let item of item.submenu">
                                <a href="javascript:void(0)" *ngIf="item.child">{{item.linkText}}</a>
                                <a routerLink="{{item.link}}" *ngIf="!item.child">{{item.linkText}}</a>
                                <ul class="sub-menu" *ngIf="item.child">
                                    <li class="menu-item" *ngFor="let item of item.submenu">
                                        <a routerLink="{{item.link}}">{{item.linkText}}</a>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </li>
                </ul>
                <!-- Controls -->
                <div class="sigma_header-controls">
                    <ul class="sigma_header-controls-inner">
                        <li>
                            <a class="sigma_search-trigger" href="javascript:void(0)" (click)="toggleSearch()">
                                <i class="fal fa-search"></i>
                            </a>
                        </li>
                        <li>
                            <a href="javascript:void(0)" class="sigma_cart-trigger" (click)="toggleCart()">
                                <i class="fal fa-shopping-bag"></i>
                            </a>
                        </li>
                        <!-- Desktop Toggler -->
                        <li class="aside-toggler aside-trigger-right desktop-toggler" (click)="toggleCanvas()">
                            <span></span>
                            <span></span>
                            <span></span>
                        </li>
                        <!-- Mobile Toggler -->
                        <li class="aside-toggler aside-trigger-left" (click)="toggleNav()">
                            <span></span>
                            <span></span>
                            <span></span>
                        </li>
                    </ul>
                </div>
            </nav>
        </div>
    </div>
    <!-- Middle Header End -->
</header>
<!-- partial -->